import { render } from "./PasswordModal.vue?vue&type=template&id=10ec5815&scoped=true"
import script from "./PasswordModal.vue?vue&type=script&lang=js"
export * from "./PasswordModal.vue?vue&type=script&lang=js"

import "@/assets/css/components/PasswordModal.scss?vue&type=style&index=0&id=10ec5815&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10ec5815"]])

export default __exports__